{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              29.06748336445247,
              41.531871280872906
            ],
            [
              28.404952244943246,
              40.91452138478053
            ],
            [
              26.17026562914694,
              40.27387966303297
            ],
            [
              25.337855281662485,
              39.002082442862076
            ],
            [
              25.86775027961812,
              37.02934903117939
            ],
            [
              28.978474316496033,
              35.66958882404596
            ],
            [
              34.94122210542801,
              35.991279512484525
            ],
            [
              41.548056888590736,
              41.56540045069258
            ],
            [
              34.49206214943541,
              42.65329946888116
            ],
            [
              29.06748336445247,
              41.531871280872906
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}